import xs from 'xstream';
import BASE_URL from './variables';
import {
  fetchExternalPolicyQuestions,
  fetchExternalPolicyQuestionsSuccess,
  fetchExternalPolicyQuestionsFailed,
  closeExternalPolicyUpdateModal,
  submitExternalPolicyUpdate,
  submitExternalPolicyUpdateSuccess,
  submitExternalPolicyUpdateFailed,
} from '../reducers/externalPolicyUpdate';

export function getExternalPolicyUpdateQuestions(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === fetchExternalPolicyQuestions.type)
        .map(action => ({
            url: BASE_URL + 'api/Applications/UpdateQuestions',
            category: 'getExternalPolicyUpdateQuestions',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    const httpResponse$ = sources.HTTP
        .select('getExternalPolicyUpdateQuestions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => fetchExternalPolicyQuestionsSuccess(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function getExternalPolicyUpdateQuestionsFailed(sources) {
    const httpResponse$ = sources.HTTP
        .select('getExternalPolicyUpdateQuestions')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => fetchExternalPolicyQuestionsFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function resetExternalPolicyUpdateOnLocationChange(sources) {
    const dispatched$ = sources.ACTION
        .filter(action => action.type === '@@router/LOCATION_CHANGE')
        .map(action => xs.of(closeExternalPolicyUpdateModal())).flatten();

    return {
        ACTION: dispatched$,
    };
}

export function submitExternalPolicyUpdateCycle(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === submitExternalPolicyUpdate.type)
        .map(action => ({
            url: BASE_URL + 'api/GlobalPolicy/Update',
            category: 'submitExternalPolicyUpdate',
            method: 'POST',
            type: 'application/json',
            send: JSON.stringify(action.payload),
            withCredentials: true
        }));

    const httpResponse$ = sources.HTTP
        .select('submitExternalPolicyUpdate')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => {
            const parsed = JSON.parse(response.text);
            return submitExternalPolicyUpdateSuccess(parsed.message);
        });

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function submitExternalPolicyUpdateFailedCycle(sources) {
    const httpResponse$ = sources.HTTP
        .select('submitExternalPolicyUpdate')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => submitExternalPolicyUpdateFailed(response));

    return {
        ACTION: httpResponse$
    };
}
